<template>
  <CustomSelect
    customOption
    class="w-52"
    :required="required"
    v-model="localValue"
    optionLabel="description"
    optionValue="id"
    :options="currencyOptions"
    :label="label"
  />
</template>

<script setup>
import CustomSelect from "./CustomSelect.vue";

import { useCurrencyTypesStore } from "../../stores/currencyTypeStore";

const currencyTypeStore = useCurrencyTypesStore();
const currencyOptions = currencyTypeStore.currencyTypes;
const props = defineProps({
  modelValue: { type: [String, Object], default: null },
  required: { type: Boolean, default: true },
  label: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue"]);

const localValue = ref(null);

const findCurrencyOption = (value) => {
  if (!value) return null;
  if (typeof value === "number") {
    return currencyOptions.find((opt) => opt.id === value);
  }
  if (typeof value === "object" && value.id) {
    return currencyOptions.find((opt) => opt.id === value.id);
  }
  return null;
};

const updateValue = (value) => {
  const option = findCurrencyOption(value);
  if (option) {
    localValue.value = option;
    emit("update:modelValue", option);
  }
};

watch(() => props.modelValue, updateValue, { immediate: true });
watch(() => localValue.value, updateValue);

onMounted(async () => {
  await nextTick();
  if (!localValue.value) {
    updateValue(props.modelValue || currencyOptions[0]);
  }
});
</script>
